const videoElements = document.getElementsByTagName("video");

function getEventObject() {
  return {
    lesson_id: NIMBLE_LESSON_ID,
    page: window.location.pathname
  }
}

if (videoElements && videoElements[0]) {
  const eventObject = getEventObject()

  const videoElement = videoElements[0]
  // v.addEventListener("seeked", function (event) {
  //     ahoy.track("$seeked", eventObject);
  // }, true);

  videoElement.addEventListener("ended", function (event) {
    console.log('video ended')
    ahoy.track("VideoEnded", eventObject);
  }, true);

  videoElement.addEventListener("play", function (event) {
    console.log('video started')
    ahoy.track("VideoStarted", eventObject);
  }, true);

  videoElement.addEventListener("pause", function (event) {
    console.log('video paused')
    ahoy.track("VideoPaused", eventObject);
  }, true);
}